export default __webpack_public_path__ + "static/media/FreightForwarderIcon.46915964.svg";